import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, Globe, Languages, ClipboardCheck } from 'lucide-react';
import SEO from '../components/SEO';
import { PageHero, FeatureGrid, CTABand } from '../components/marketing';

const TESTS = [
  { Icon: Languages, title: 'IELTS', desc: 'Academic & General. Diagnostic + 12-week structured prep. Average score lift of 1.0 band.', items: ['Live mock interviews', 'Weekly writing reviews', 'Exam-day strategy'] },
  { Icon: Globe, title: 'CLBPT', desc: 'Canadian Language Benchmarks Placement Test for newcomers. Online & in-person.', items: ['Practice rubrics', 'Speaking labs', 'Booking support'] },
  { Icon: ClipboardCheck, title: 'ACCUPLACER', desc: 'Used by 1,500+ North American colleges. Reading, writing, math.', items: ['Math refresher', 'Adaptive practice', 'Score interpretation'] },
  { Icon: BookOpen, title: 'iTEP', desc: 'Internet-based English test accepted by 700+ institutions.', items: ['Section-by-section coaching', 'Tech setup help', 'Retake strategy'] },
];

export default function TestPrepPage() {
  return (
    <div className="bg-tge-paper min-h-screen">
      <SEO title="Test Preparation — True Global Education" />
      <PageHero
        eyebrow="Test preparation"
        title="The score is the gate. We get you through it."
        intro="Tutoring that is structured, paced and graded — not just videos and PDFs. Our average IELTS student gains a full band in 12 weeks."
      />
      <FeatureGrid items={TESTS} columns={2} />
      <CTABand
        title="Book a free diagnostic"
        body="Find out exactly where you stand and how far you have to go — in 60 minutes, free."
        primary={
          <Link
            to="/contact"
            className="bg-tge-gold hover:bg-tge-gold-soft text-tge-navy font-semibold px-7 py-3.5 rounded-full inline-flex items-center gap-2 transition"
          >
            Book diagnostic <ArrowRight size={17} />
          </Link>
        }
      />
    </div>
  );
}
